document.addEventListener("DOMContentLoaded", function () {
  const mainImage = document.getElementById("mainImage");
  const thumbs = document.querySelectorAll(".thumb");

  if (!mainImage || thumbs.length === 0) return;

  thumbs.forEach((thumb) => {
    thumb.addEventListener("click", function () {

      // change main image
      mainImage.src = this.dataset.full;

      // active class
      thumbs.forEach(t => t.classList.remove("active"));
      this.classList.add("active");

    });
  });
});